import { render } from "./producPage.vue?vue&type=template&id=0e70d696"
import script from "./producPage.vue?vue&type=script&lang=js"
export * from "./producPage.vue?vue&type=script&lang=js"

import "./producPage.vue?vue&type=style&index=0&id=0e70d696&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__